import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/main/alert.service';
import { OpUser } from 'src/app/model/a2srv-operation/auth-models/opuser-model';
import { UrlPrefixes } from 'src/app/model/cms-btv-core/config-controller/config-url-prefix.model';
import { UrlPrefixesService } from 'src/app/services/cms-btv-core/url-prefix-controller/url-prefixes.service';
import { environment } from 'src/environments/environment';
import { DataSharingService } from '../../main/data-sharing.service';
import { Utility } from '../../utility/utility';
import { ThemeService } from '../../main/theme.service';
import { AuthService } from '../auth.service';
import { AuthenticationInput } from '../model/models';

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  authInput: AuthenticationInput;
  failedMessage: string = '';
  currentUser: OpUser;
  login: boolean = false;
  class1: string = 'btn btn-primary btn-block';
  class2: string = 'btn btn-primary btn-block btn-loading';
  isCaptcha: boolean = false;
  sitekey: string = '';
  recaptcha: any = {};
  recaptchaResponse: any = '';
  reCapt: any;
  captchaCheck: boolean = false;

  btvPrefixes: UrlPrefixes[];
  urlPrefixesone: UrlPrefixes[];

  constructor(
    private router: Router,
    private authService: AuthService,
    private dataSharing: DataSharingService,
    private urlPrefixService: UrlPrefixesService,
    private alert: AlertService,
    private utility: Utility,
    private themeService: ThemeService,
  ) {
    this.themeService.applyForCurrentView('light');
    this.authInput = {};
    this.authInput.sessionID = '135465789';
  }

  ngOnInit(): void {
    this.recaptcha = (window as any).grecaptcha;
    this.getSitekey();
  }

  storeRecaptchaResponse(event: any, reCapt: any): void {
    this.recaptchaResponse = event.response;
    this.reCapt = reCapt;
    this.captchaCheck = true;
  }

  getSitekey(): void {
    this.authService.getSiteKey().subscribe((response) => {
      if (response.code == 200) {
        this.sitekey = response.data;
      } else {
        this.alert.error(response.message);
      }
    });
  }

  signIn(forceLogin?: boolean): void {
    this.authService.loginUser(this.authInput, this.recaptchaResponse, forceLogin).subscribe((response) => {
      if (response.code == 200) {
        this.currentUser = response.data;

        localStorage.setItem('token', this.currentUser.token);
        localStorage.setItem('drm_token', this.currentUser.drmToken);
        this.dataSharing.sendUserData(this.currentUser);
        this.authService.setUserLoggedIn();
        this.authService.setUserRole(this.currentUser.role);
        localStorage.setItem('user.role', this.currentUser.role.name);
        localStorage.setItem('isAdmin', JSON.stringify(this.currentUser.role.isAdmin));
        localStorage.setItem('username', this.currentUser.username);
        localStorage.setItem('userID', this.currentUser.id + '');
        localStorage.setItem('urls', JSON.stringify(this.currentUser.opuiUrls));
        localStorage.setItem('pagePermissions', JSON.stringify(this.currentUser.role.pagePermissions || []));
        localStorage.removeItem('softwareLicenseCapacityWarningShown');
        this.getUrlPrefixes();
        this.authService.keepAlive();
        this.login = true;
        // if (this.currentUser.role.privileges.includes('TrailerWorkFlow')) {
        //   this.router.navigate(['/atlas/cms/trailerworkflow']);
        // } else {
        this.router.navigate(['/atlas/cms/dashboard']);
        // }
        document.getElementById('modal-forcelogin').classList.remove('fade');
        $('#modal-forcelogin').modal('hide');
      } else if (response.code == 62) {
        $('#modal-forcelogin').modal('show');
        this.login = false;
      } else {
        this.recaptcha = (window as any).grecaptcha;

        if (this.isCaptcha && this.captchaCheck) {
          this.reCapt.reset();
        } else {
          this.isCaptcha = true;
        }

        this.login = false;
        this.router.navigate(['/login']);
        this.failedMessage = 'Login Failed.';
        this.alert.error(response.message);
      }
      this.setLocationPrefixes();
    });
  }

  onKeydown(event: any): void {
    if (event.key === 'Enter') {
      this.signIn();
    }
  }

  getUrlPrefixes(): void {
    this.urlPrefixService.getContentUrlPrefixes().subscribe((response) => {
      this.urlPrefixesone = response;
      response.filter((item) => {
        if (item.name == 'Content') {
          localStorage.setItem('contentUrlPrefixName', item.name);
          localStorage.setItem('contentPrefixUrl', item.url);
          this.dataSharing.setContentUrlPrefix(item);
        } else if (item.name == 'Category') {
          localStorage.setItem('categoryUrlPrefixName', item.name);
          localStorage.setItem('categoryPrefixUrl', item.url);
          this.dataSharing.setCategoryUrlPrefix(item);
        } else if (item.name == 'Catchup') {
          localStorage.setItem('catchupUrlPrefixName', item.name);
          localStorage.setItem('catchupPrefixUrl', item.url);
          this.dataSharing.setCatchupUrlPrefix(item);
        } else if (item.name == 'Contract') {
          localStorage.setItem('contractUrlPrefixName', item.name);
          localStorage.setItem('contractPrefixUrl', item.url);
          this.dataSharing.setContractUrlPrefix(item);
        } else if (item.name == 'Cast') {
          localStorage.setItem('castUrlPrefixName', item.name);
          localStorage.setItem('castPrefixUrl', item.url);
          this.dataSharing.setCastUrlPrefix(item);
        } else if (item.name == 'Report') {
          localStorage.setItem('Report', item.name);
          localStorage.setItem('reports', item.url);
          this.dataSharing.setReportPrefix(item);
        } else if (item.name == 'Menuitem') {
          localStorage.setItem('menuItemUrlPrefixName', item.name);
          localStorage.setItem('menuItemPrefixUrl', item.url);
          this.dataSharing.setMenuItemUrlPrefix(item);
        } else if (item.name == 'Temp') {
          localStorage.setItem('tempPosterUrl', item.url);
        } else if (item.name == 'ComingSoon') {
          localStorage.setItem('ComingSoonUrlPrefixName', item.name);
          localStorage.setItem('ComingSoonPrefixUrl', item.url);
          this.dataSharing.setComingSoonUrlPrefix(item);
        } else if (item.name == 'provider') {
          localStorage.setItem('providerUrlPrefixName', item.name);
          localStorage.setItem('providerPrefixUrl', item.url);
          this.dataSharing.setProviderUrlPrefix(item);
        }
      });
    });

    this.urlPrefixService.getBtvPrefixes().subscribe((response) => {
      this.btvPrefixes = response;
      this.btvPrefixes.filter((prefix) => {
        if (prefix.name == 'Epg') {
          localStorage.setItem('epgUrlPrefixName', prefix.name);
          localStorage.setItem('epgPrefixUrl', prefix.url);
          this.dataSharing.setEpgPrefixes(prefix);
        } else if (prefix.name == 'DownloadedCdnFiles') {
          localStorage.setItem('downloadedCdnFiles', prefix.name);
          localStorage.setItem('cndFilesPrefix', prefix.url);
          this.dataSharing.setDownloadedCndFilesPrefix(prefix);
        }
      });
    });
  }

  setLocationPrefixes(): void {
    //if (environment.production) {
    localStorage.setItem('locationPrefix', window.location.protocol + '//' + window.location.host + '/');
    //} else if (environment.staging || environment.development) {
    //  localStorage.setItem('locationPrefix', environment.endPoint.substring(0, environment.endPoint.indexOf(':8188')));
    //}
  }
  headerManipulator(): void {
    // if (window.location.host.includes('10.98.228.146') || window.location.host.includes('localhost:4200')) {
    //   let pxNavbar = document.getElementById('pxNavbar');
    //
    //   //  pxNavbar.style.backgroundColor = 'red';
    // }
  }
}
